import { Article, ArticleSearch, ProductArticles } from '@article/const';
import { StateUtils } from '@spartacus/core';

export const ARTICLE_FEATURE = 'article';
export const ARTICLES_SEARCH = '[Article] Articles Search';
export const ARTICLE = '[Article] Article';
export const PRODUCT_ARTICLES = '[Article] Product Articles';

export interface StateWithArticle {
  [ARTICLE_FEATURE]: ArticleState;
}

export interface StateWithArticleSearch {
  [ARTICLES_SEARCH]: ArticleState;
}

export interface ArticleState {
  articlesSearch: StateUtils.LoaderState<ArticleSearch>;
  article: StateUtils.EntityLoaderState<Article>;
  productArticles: StateUtils.EntityLoaderState<ProductArticles>;
}
